import {
  selectCurrentMerchant,
  selectCurrentMerchantId,
} from 'redux/app/merchant/merchant.selectors';
import { getStore } from 'redux/store';

export const getMerchantId = () =>
  selectCurrentMerchantId(getStore().getState());

export const getCurrentMerchant = () =>
  selectCurrentMerchant(getStore().getState());
